import React, { useEffect, useState } from 'react'
import { Col, Row, Table } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import DotStatus from 'components/DotStatus/DotStatus'
import moment from 'moment'
const _ = require('lodash')

const columns = [
  { label: 'dashboard_name', name: 'name', filter: 'asc' },
  { label: 'dashboard_e-mail', name: 'email', filter: null },
  { label: 'dashboard_last-login', name: 'loginAt', filter: null },
  { label: 'dashboard_brand', name: 'brand', filter: null },
  { label: 'dashboard_delegation', name: 'delegation', filter: null },
  { label: 'dashboard_rol', name: 'role', filter: null },
  { label: 'dashboard_state', name: 'status', filter: null },
]

// eslint-disable-next-line react/display-name
export default ({ operators : operatorFromProps, companies, history, match, header, addUser = false, user }) => {
  const [sortType, setSortType] = useState('asc')
  const [sortColumn, setSortColumn] = useState('name')
  const [operators, setOperators] = useState(operatorFromProps.length > 0 ? operatorFromProps.sort((a,b) => (a.name || '').localeCompare(b.name)) : [])

  useEffect(()=> {
    toggleOrder(sortColumn, sortType)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [operatorFromProps])

  const companyOperatorsList = () =>
    operators.map((operator, key) => {
      return (
        <tr
          key={key}
          className={`${user === operator._id && 'operator-active'}`}
          onClick={() => user !== operator._id && history.push(`${match.url}/operator?id=${operator._id}`)}
        >
          <td className={'align-middle avatar-row'}>
            <div className='avatar align-middle' style={{ backgroundImage: `url(${operator.picture || 'img/default.png'})` }} />
          </td>
          <td className={'align-middle name'}>{`${operator.name || ''} ${operator.lastname || ''}`}</td>
          <td className={'align-middle email'}>{operator.email}</td>
          <td className={'align-middle'}>{operator.loginAt ? moment(operator.loginAt).format('DD/MM/YYYY HH:mm:ss') : ''}</td>
          {operator.brandNames && <td className={'align-middle'}>{operator.brandNames.map(({ name }) => name).join(', ')}</td>}
          {operator.delegationNames && <td className='align-middle'>{operator.delegationNames.map(({ name }) => name).join(', ')}</td>}
          <td className={'align-middle'}>{I18n.t(`roles_${operator.role}`)}</td>
          <td className={'align-middle'}>
            <DotStatus operatorStatus={operator.status} /> {I18n.t(`operators_status_${operator.status}`)}
          </td>
        </tr>
      )
    })

  const toggleOrder = (field, type) => {
    if (field === 'brand' || field === 'delegation')
      return

    const _operators = _.cloneDeep(operatorFromProps)
    let _sortType = !type ? sortType === 'desc' ? 'asc' : 'desc' : type

    setSortColumn(field)
    if (field === 'loginAt') {
      setOperators(_operators.sort((a,b) => {
        let dateA = moment(a[field] || '01/01/1900')
        let dateB = moment(b[field] || '01/01/1900')
        if (_sortType === 'desc') {
          if (dateA.isAfter(dateB))
            return -1
        }
        else {
          if (dateA.isBefore(dateB))
            return -1
        }
        return 0
      }))
    } else
      setOperators(_operators.sort((a,b) => _sortType === 'asc' ? (a[field] || '').localeCompare(b[field]) : (a[field] || '').localeCompare(b[field])*-1))

    setSortType(_sortType)
  }

  return addUser || operators.length ? (
    <Row className='mb-3 new-size-font'>
      <Col xs={12} className='mb-2'>
        <h2>
          {header}
          {addUser && (
            <i
              className='fa fa-plus pl-2'
              onClick={() => {
                history.push(`${match.url}/operator`)
              }}
              id='addOperator'
            />
          )}
        </h2>
      </Col>

      <Col xs={12}>
        <Table hover responsive size={'sm'}>
          <thead>
            <tr>
              <th scope='col' />
              {
                columns.map((it, idx) =>
                  <th scope='col' className={it.name} key={idx}>
                    <span onClick={()=> toggleOrder(it.name) }>
                      {I18n.t(it.label)}
                      {sortColumn === it.name && <i className={`fa fa-sort-${sortType === 'asc' ? 'up' : 'down'} pl-1`} />}
                    </span>
                  </th>
                )
              }
            </tr>
          </thead>
          <tbody>{companyOperatorsList()}</tbody>
        </Table>
      </Col>
    </Row>
  ) : (
    ''
  )
}
